import React, { FC } from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled, CloseCircleFilled, MobileOutlined } from "@ant-design/icons";
import "./DigitalSignatureModal.css";

export type SignatureStatus = "idle" | "pending" | "success" | "failure";

interface ModalContent {
  title?: React.ReactNode;
  description?: React.ReactNode;
}

interface Props {
  status: SignatureStatus;
  onClose: () => void;
  onRetry?: () => void;
  onConfirmSuccess?: () => void;
  pendingContent?: ModalContent;
  successContent?: ModalContent;
  failureContent?: ModalContent;
}

const DigitalSignatureModal: FC<Props> = ({
  status,
  onClose,
  onRetry,
  onConfirmSuccess,
  pendingContent,
  successContent,
  failureContent,
}) => {
  const isOpen = status !== "idle";

  const renderContent = () => {
    const wrapperClass = `ds-icon-wrapper ${status === "pending" ? "pulse" : status === "success" ? "scale-up success" : "shake failure"}`;

    switch (status) {
      case "pending":
        return (
          <div className="ds-modal-content pending">
            <div className={wrapperClass}>
              <MobileOutlined className="ds-main-icon" rev="" />
            </div>
            <h3 className="ds-title">{pendingContent?.title || "Xác thực qua ứng dụng di động"}</h3>
            <p className="ds-description">
              {pendingContent?.description || "Vui lòng mở ứng dụng di động và xác thực để ký số văn bản"}
            </p>
          </div>
        );
      case "success":
        return (
          <div className="ds-modal-content success">
            <div className={wrapperClass}>
              <CheckCircleFilled className="ds-main-icon success" rev="" />
            </div>
            <h3 className="ds-title">{successContent?.title || "Ký số thành công"}</h3>
            <p className="ds-description">
              {successContent?.description || "Văn bản đã được ký và chuyển đến bước tiếp theo"}
            </p>
            <Button type="text" className="ds-btn-finish" onClick={onConfirmSuccess}>
              Tiếp tục
            </Button>
          </div>
        );
      case "failure":
        return (
          <div className="ds-modal-content failure">
            <div className={wrapperClass}>
              <CloseCircleFilled className="ds-main-icon failure" rev="" />
            </div>
            <h3 className="ds-title">{failureContent?.title || "Ký số không thành công"}</h3>
            <p className="ds-description">{failureContent?.description || "Vui lòng thử lại"}</p>
            <div className="ds-action-group">
              <Button onClick={onRetry} type="text" className="btn-text">
                Thử lại
              </Button>
              <Button type="text" onClick={onClose} className="btn-text">
                Hủy bỏ
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={true}
      maskClosable={false}
      keyboard={false}
      centered
      width={400}
      className="digital-signature-modal"
      destroyOnClose
    >
      {renderContent()}
    </Modal>
  );
};

export default DigitalSignatureModal;
